<template>
  <div class="about_box">
    <div class="threepart" v-show="thisindex == 0">
      <img src="../../assets/images/aboutbanner12.jpg" alt="">
      <div class="content">
        <div class="textbox">
          <p>高山书院（GASA）意从《诗经》：“高山仰止，景行行止”。是一所致力于培养具有科学精神的未来领袖的新型大学，由长城会创始人文厨于2016年发起。 以“科学复兴（New Scientific Renaissance）”为愿景，以“没有受教，求知探索（No Education Only Learning）”为校训，每年与30名学员一起身体力行，走遍科学重镇，探索科学精神。</p>
          <p>跟随国内外科学家，用科学真理探索人类发展终极目标。聚焦前沿研究，生物基因、人工智能、材料、太空等未来趋势一网打尽，用学科跨界打破思维定式。GASA终身学习服务，线上内容更新+线下社群活动，一次入学，一生探索。</p>
          <p>发展至今，高山书院（GASA）校董会扩编至11人，课程板块覆盖信息科学、物质科学、生命科学、通识与本地化等四大领域，科学家导师高达112人，优秀企业家、创业者、投资人学员达百余名。探索足迹遍布美国、中国、以色列、印度、希腊、土耳其、意大利、英国等不同国家与地区。</p>
        </div>
      </div>
    </div>
    <div class="threepart" v-show="thisindex == 1">
      <img src="../../assets/images/aboutbanner2.jpg" alt="">
      <div class="content course">
        <div class="textbox">
          <b>一、信息科学模块</b>
          <p>-覆盖人工智能、计算机、通讯、数字多媒体等领域<br>
            -教学领头人：李开复、张宏江</p>
          <b>二、物质科学模块</b>
          <p>-覆盖物理学和化学两大领域，包含新能源、纳米、量子、空间探索等<br>
          -教学领头人：杨培东、崔屹、周忠和</p>
          <b>三、生命科学模块</b>
          <p>-覆盖基因科学、脑科学、环境等领域，包括生物制药、基因工程等<br>
          -教学领头人：鲁白</p>
          <b>四、通识和本地化模块</b>
          <p>-覆盖科学史、方法论、人文科学以及与游学当地特色结合的课程<br>
          -教学领头人：文厨、吴国盛、薛澜、袁征</p>
          <b>五、数学模块</b>
          <p>-覆盖基础数学、应用数学、计算数学、概率与统计等领域，以及与⼯程领域等相关的交叉学科领域<br>
          -教学领头人：夏志宏</p>
        </div>
      </div>
    </div>
    <div class="threepart" v-show="thisindex == 2">
      <img src="../../assets/images/aboutbanner3.jpg" alt="">
      <div class="content">
        <div class="textbox">
          <ul>
            <li><p>来GASA放空自己，重新刷新，升级自己的知识结构。三人行必有我师，我喜欢在这种多元的同学圈中学习和发现新的东西。</p><p class="name">—梁信军，复星集团，联合创始人</p><img src="../../assets/images/dashed.png" alt=""></li>
            <li><p>作为文科教授，我希望来到高山书院改变身上的标签，培养科学素质。</p><p class="name">—蒋昌建，复旦大学副教授、著名主持人</p><img src="../../assets/images/dashed.png" alt=""></li>
            <li><p>科技是时代秀，当科技回到人，你会发现，那些无用之物必有大用。</p><p class="name">—周航，顺为资本，投资合伙人</p><img src="../../assets/images/dashed.png" alt=""></li>
            <li><p>在全球各地接触最顶尖人士从不同角度分析行业内在驱动力，他们对文化和未来的不同认知给我带来很多帮助。</p><p class="name">—萧泓，完美世界，CEO</p><img src="../../assets/images/dashed.png" alt=""></li>
            <li><p>我觉得科学本质上就是研究世界的本质。而商业和科学之间有很多共通之处。</p><p class="name">—董荣杰，虎牙科技，CEO</p></li>
          </ul>
        </div>
      </div>
    </div>
    <div class="three1" @mousemove="changeModal(0)"></div>
    <div class="three2" @mousemove="changeModal(2)"></div>
    <div class="three3" @mousemove="changeModal(1)"></div>
  </div>
</template>
<style lang="less" scoped>
@import "about.page.less";
</style>
<script>
export default {
  data () {
    return {
      thisindex: 0,
      id: ''
    }
  },
  created () {
    let id = this.$route.params.id
    console.log(1111111)
    console.log(id)
    this.thisindex = parseInt(id)
    // console.log(this.thisindex)
  },
  watch: {
    $route () {
      this.id = this.$route.params.id
    },
    id () {
      this.thisindex = parseInt(this.id)
    }
  },
  methods: {
    changeModal: function (modalnum) {
      this.thisindex = modalnum
    }
  }
}
</script>





// WEBPACK FOOTER //
// src/pages/about/about.page.vue